import React from 'react';

const SkeletonLoader = ({
  variant = 'text',
  count = 1,
  className = '',
  width,
  height,
}) => {
  const variants = {
    text: 'h-4 bg-neutral-200 rounded',
    title: 'h-8 bg-neutral-200 rounded',
    avatar: 'w-12 h-12 rounded-full bg-neutral-200',
    card: 'h-32 bg-neutral-200 rounded-xl',
    image: 'h-48 bg-neutral-200 rounded-lg',
    button: 'h-10 w-24 bg-neutral-200 rounded-lg',
  };

  const skeletonClass = [
    'animate-pulse shimmer',
    variants[variant] || variants.text,
    className,
  ].filter(Boolean).join(' ');

  const style = {
    ...(width && { width }),
    ...(height && { height }),
  };

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={skeletonClass}
          style={style}
        />
      ))}
    </>
  );
};

export const SkeletonTable = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex gap-4">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <SkeletonLoader key={colIndex} className="flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
};

export const SkeletonCard = () => {
  return (
    <div className="bg-white rounded-xl p-6 border border-neutral-200 space-y-4">
      <SkeletonLoader variant="title" width="60%" />
      <SkeletonLoader variant="text" count={3} />
      <div className="flex gap-2 pt-4">
        <SkeletonLoader variant="button" />
        <SkeletonLoader variant="button" />
      </div>
    </div>
  );
};

export default SkeletonLoader;
